import { useState, useEffect } from 'react';
import { apiFetch } from '../../../lib/api.js';

// bpartnerId starts as null (nothing chosen yet) rather than '' — '' is reserved as the
// explicit "file under my own organization" choice, so the two states stay distinguishable
// and an agent is forced to make one or the other rather than silently defaulting to own-org.
export const DRAFT_DEFAULTS = {
  type: '', module: '', priority: '', bpartnerId: null, contactId: '',
  summary: '', description: '', docNumber: '', attachments: [], clusterId: '',
  // { id, summary, docNumber } of an existing ticket picked in the duplicate check.
  relatedTo: null,
  // Value + validity of the optional 'request.create.extraFields' fieldset.
  extra: null, extraValid: true,
};

// Fetches the contact list scoped to the chosen business partner (agent-only lookup).
// reloadToken is a manual-refresh trigger: a contact added via the WebUI while this
// dropdown is already open on the same bpartner otherwise never shows up, since
// bpartnerId itself hasn't changed - refetch() lets the user pull it in on demand
// instead of losing their in-progress draft to a full page reload.
export function useContactsForBPartner(bpartnerId) {
  const [contacts, setContacts] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!bpartnerId) {
      setContacts([]);
      return;
    }
    const controller = new AbortController();
    apiFetch(`/lookups/contacts?bpartner_id=${encodeURIComponent(bpartnerId)}`, { signal: controller.signal })
      .then(data => setContacts(Array.isArray(data) ? data : (data?.data ?? [])))
      .catch(err => { if (err.name !== 'AbortError') setContacts([]); });
    return () => controller.abort();
  }, [bpartnerId, reloadToken]);

  const refetch = () => setReloadToken(v => v + 1);
  return [contacts, refetch];
}
